  <div class="carousel-container">
    <div class="carousel" #carouselWrapper>
      @for (item of carouselItems; track $index; let i = $index) {
      <div class="carousel-card"
        [ngClass]="{ 'first-card': i === 0, 'last-card': i === carouselItems.length - 1, 'not-clickable': !isOpenable(item) }"
        (click)="goToProject(item)">
        <img [src]="item.imageUrl" class="img-fluid" />
        <div class="card-caption">
          <span class="pill">{{ item.location }}</span>
          <span class="title">{{ item.title }}</span>
          <span class="description">{{ item.description }}</span>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="carousel-arrows">
    <div class="custom-button" [class.disabled]="isAtStart" (click)="scrollLeft()"><i
        class="fa-light fa-angle-left"></i></div>
    <div class="custom-button" [class.disabled]="isAtEnd" (click)="scrollRight()"><i
        class="fa-light fa-angle-right"></i></div>
  </div>